import HGStatus from 'components/HGStatus';
import HGClickToCopy from 'components/HGClickToCopy';
import EditNameButton from 'components/EditNameButton';
import { ViewLogsButton } from 'components/DeviceLogs/ViewLogsButton';
import CounterBadge from 'components/Alerts/CounterBadge';
import { checkStackAlerts } from 'components/DeviceDetails/helper';

export const batteryStacksTableColumns = [
    {
        Header: 'Status',
        accessor: 'status',
        component: (item) => {
            const currentTime = Date.now() / 1000;
            const isOnline = item.ts && item.ts + 60 * 10 > currentTime;
            return <HGStatus online={isOnline} />;
        },
    },
    {
        Header: 'Alerts',
        accessor: 'active_alerts',
        component: (item) => <CounterBadge item={checkStackAlerts(item.MASTER_SN, item.PACKS, item.active_alerts)} />,
    },
    {
        Header: 'Name',
        accessor: 'MasterName',
        component: (item) => (
            <EditNameButton item={{ ...item, fromTable: true }} />
        ),
    },
    {
        Header: 'Charge (%)',
        accessor: 'SoC',
    },
    {
        Header: 'Health (%)',
        accessor: 'SoH',
    },
    {
        Header: 'Current',
        accessor: 'current',
    },
    {
        Header: 'State',
        accessor: 'charging',
    },
    {
        Header: 'Temperature (°C)',
        accessor: 'temp_c',
    },
    {
        Header: 'Serial Number',
        accessor: 'MASTER_SN',
        component: (item) => (
            <HGClickToCopy content={item?.MASTER_SN}>
                <span className="text-foreground">
                    {item?.MASTER_SN}
                </span>
            </HGClickToCopy>
        ),
    },
    {
        Header: "Logs",
        accessor: "online",
        component: (item) => <ViewLogsButton device={item}>View Logs</ViewLogsButton>,
        nosort: true
    },
];
